import React from "react";
import styles from "./styles.module.scss";
import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import AudioPlayer from "app/components/AudioPlayer";
import VideoViewer from "./_components/VideoViewer";
import { AnalyticsService } from "app/services";

interface PostMediaModalProps {
  isOpen: boolean;
  onClose: () => void;
  mediaData: any;
}

const PostMediaModal = ({
  isOpen,
  onClose,
  mediaData,
}: PostMediaModalProps) => {
  const { type, originalUrl, url } = mediaData || {};

  if (!isOpen) {
    return null;
  }

  const RenderMedia = () => {
    if (type === "image") {
      return <img className={styles.thumbnail} src={originalUrl} alt="media" />;
    }

    if (type === "video") {
      AnalyticsService.track("Is Multicam: true", mediaData);
      return <VideoViewer videoMedia={mediaData} />;
    }

    if (type === "audio") {
      return (
        <div className={styles.audio_container}>
          <AudioPlayer data={mediaData} />
        </div>
      );
    }

    return null;
  };

  return (
    <ModalLayout isOpen={isOpen} onClose={onClose}>
      <div className={styles.modal_navbar}>
        <a href={originalUrl || url} target="_blank" rel="noopener noreferrer">
          <i className="ico ico-open" />
        </a>
        <i className="ico ico-x" onClick={onClose} />
      </div>
      <div className={styles.content}>
        <RenderMedia />
      </div>
    </ModalLayout>
  );
};

export default PostMediaModal;
